import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_banner_viewed',
            props: {
                ...segmentProps,
                banner_id: '#context.alertId',
                cta_text: '?#context.ctaText',
                destination: '?#context.href',
                source: '?@router.location.pathname',
            },
        },
    },
};
